import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportService } from 'src/app/Services/report.service';

@Component({
  selector: 'ze-log-view',
  templateUrl: './log-view.component.html',
  styleUrls: ['./log-view.component.scss']
})
export class LogViewComponent implements OnInit {

  logFile: string = null;
  logData: string = null;
  logNotFound: boolean = false;

  constructor(private route: ActivatedRoute,
    private reportService: ReportService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.logFile = params['reportId'];
      this.reportService.getExecutionLog(this.logFile).subscribe((logBlob: Blob) => {
        const reader = new FileReader();
            reader.onload = () => {
                this.logData = reader.result as string;
            };
            reader.readAsText(logBlob);
      },
      (error) => {
        this.logNotFound = true;
      });
    });
  }

}
